import {API_URL} from '../../tenant/apiBase'

export type AuthPublicLinks = {
  terms: string
  plans: string
  contact: string
}

export function authPublicLinks(language: string, publicSite = API_URL): AuthPublicLinks {
  const locale = language === 'ar' ? 'ar' : 'en'
  const baseUrl = publicSite.replace(/\/$/, '')

  return {
    terms: `${baseUrl}/${locale}/hisbeh-terms-conditions`,
    plans: `${baseUrl}/${locale}/partners/sell-with-us`,
    contact: `${baseUrl}/${locale}/information/contact`,
  }
}
